// extracted by mini-css-extract-plugin
module.exports = {"container":"RecentActivitiesHeader_container__24YQ7","header":"RecentActivitiesHeader_header__rsfbz","view-all-link":"RecentActivitiesHeader_view-all-link__25uLH"};